module.exports = __webpack_public_path__ + "img/268-4.68de6e31.png";